export const RESET_STATE = 'RESET_STATE';

interface ResetStateAction {
  type: typeof RESET_STATE;
}

export type OneFormActionTypes = ResetStateAction;
